import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Button } from '../Button';
import { Checkbox } from '../Checkbox';
import { AlertErrorIcon, AlertInfoIcon, AlertSuccessIcon, AlertWarningIcon } from '../icons';
import { withTranslate } from '../util';
import { StyledMessage, StyledModal, StyledModalBody, StyledModalFooter, StyledModalHeader, StyledNoShowAgain, StyledTitle } from './modalAlert.styled';
import { showModal } from './showModal';
export var warningMessageModal = createModalAlert({
  modalType: 'WarningModal'
});
export var errorMessageModal = createModalAlert({
  modalType: 'ErrorModal'
});
export var successMessageModal = createModalAlert({
  modalType: 'SuccessModal'
});
export var infoMessageModal = createModalAlert({
  modalType: 'InfoModal'
});
export var warningConfirmModal = createModalAlert({
  modalType: 'WarningModal',
  showCancel: true
});
export var infoConfirmModal = createModalAlert({
  modalType: 'InfoModal',
  showCancel: true
});
function createModalAlert(createProps) {
  var AlertModal = function AlertModal(props) {
    return /*#__PURE__*/React.createElement(ModalAlert, _extends({}, props, createProps));
  };
  AlertModal.displayName = createProps.modalType;
  return function (props) {
    showModal(/*#__PURE__*/React.createElement(AlertModal, props));
  };
}
var iconSize = 35;
export var _ModalAlert = /*#__PURE__*/function (_React$Component) {
  function _ModalAlert() {
    var _this;
    _classCallCheck(this, _ModalAlert);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _ModalAlert, [].concat(args));
    _defineProperty(_this, "state", {
      dontShowAgain: false,
      isLoading: false
    });
    _defineProperty(_this, "onChange", function (value) {
      return _this.setState({
        dontShowAgain: value
      });
    });
    _defineProperty(_this, "shouldDisplayModal", function () {
      if (!!_this.props.dontShowAgainKey) {
        return localStorage.getItem(_this.props.dontShowAgainKey) !== 'true';
      }
      return true;
    });
    _defineProperty(_this, "setNoShowAgainKeyIfNecessary", function () {
      if (_this.state.dontShowAgain && _this.props.dontShowAgainKey) {
        localStorage.setItem(_this.props.dontShowAgainKey, _this.state.dontShowAgain.toString());
      }
    });
    _defineProperty(_this, "onContinue", function () {
      _this.setNoShowAgainKeyIfNecessary();
      if (_this.props.beforeCloseSuccess) {
        _this.setState({
          isLoading: true
        });
        _this.props.beforeCloseSuccess().then(function () {
          var _this$props$onCloseSu, _this$props;
          _this.setState({
            isLoading: false
          });
          (_this$props$onCloseSu = (_this$props = _this.props).onCloseSuccess) === null || _this$props$onCloseSu === void 0 ? void 0 : _this$props$onCloseSu.call(_this$props);
        })["catch"](function () {
          _this.setState({
            isLoading: false
          });
        });
      } else {
        var _this$props$onCloseSu2, _this$props2;
        (_this$props$onCloseSu2 = (_this$props2 = _this.props).onCloseSuccess) === null || _this$props$onCloseSu2 === void 0 ? void 0 : _this$props$onCloseSu2.call(_this$props2);
      }
    });
    _defineProperty(_this, "onReject", function () {
      var _this$props$onDismiss, _this$props3;
      _this.setNoShowAgainKeyIfNecessary();
      (_this$props$onDismiss = (_this$props3 = _this.props).onDismiss) === null || _this$props$onDismiss === void 0 ? void 0 : _this$props$onDismiss.call(_this$props3);
    });
    return _this;
  }
  _inherits(_ModalAlert, _React$Component);
  return _createClass(_ModalAlert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.shouldDisplayModal()) {
        var _this$props$onCloseSu3, _this$props4;
        (_this$props$onCloseSu3 = (_this$props4 = this.props).onCloseSuccess) === null || _this$props$onCloseSu3 === void 0 ? void 0 : _this$props$onCloseSu3.call(_this$props4);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.shouldDisplayModal()) {
        return null;
      }
      var _this$props5 = this.props,
        modalType = _this$props5.modalType,
        t = _this$props5.t;
      var Icon;
      var defaultTitle;
      switch (modalType) {
        case 'SuccessModal':
          Icon = AlertSuccessIcon;
          defaultTitle = t('citrix-ui:alert_modal.success_title');
          break;
        case 'InfoModal':
          Icon = AlertInfoIcon;
          defaultTitle = t('citrix-ui:alert_modal.information_title');
          break;
        case 'WarningModal':
          Icon = AlertWarningIcon;
          defaultTitle = t('citrix-ui:alert_modal.warning_title');
          break;
        case 'ErrorModal':
          Icon = AlertErrorIcon;
          defaultTitle = t('citrix-ui:alert_modal.error_title');
          break;
      }
      return /*#__PURE__*/React.createElement(StyledModal, _extends({}, this.props, {
        title: undefined,
        closeOnOverlayClick: this.state.isLoading ? false : this.props.closeOnOverlayClick
      }), /*#__PURE__*/React.createElement(StyledModalHeader, null, /*#__PURE__*/React.createElement(Icon, {
        size: iconSize
      }), /*#__PURE__*/React.createElement(StyledTitle, null, this.props.title || defaultTitle)), /*#__PURE__*/React.createElement(StyledModalBody, null, /*#__PURE__*/React.createElement(StyledMessage, null, this.props.message)), /*#__PURE__*/React.createElement(StyledModalFooter, null, !!this.props.dontShowAgainKey && /*#__PURE__*/React.createElement(StyledNoShowAgain, null, /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.dontShowAgain,
        onChange: this.onChange
      }, t('citrix-ui:messageDialog.doNotShowThisAgain'))), /*#__PURE__*/React.createElement(Button.Group, null, /*#__PURE__*/React.createElement(Button.Primary, {
        onClick: this.onContinue,
        active: this.state.isLoading,
        disabled: this.props.disablePrimaryButton
      }, this.props.confirmButtonText || (this.props.showCancel ? t('citrix-ui:continue') : t('citrix-ui:messageDialog.ok'))), this.props.showCancel && /*#__PURE__*/React.createElement(Button.Secondary, {
        onClick: this.onReject,
        disabled: this.state.isLoading
      }, this.props.cancelButtonText || t('citrix-ui:cancel')))));
    }
  }]);
}(React.Component);
_defineProperty(_ModalAlert, "defaultProps", {
  disablePrimaryButton: false
});
var ModalAlert = withTranslate(_ModalAlert);